var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M443 475L443 503",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.5,
    cy: 470.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M438.987 470.19C438.987 466.283 442.288 463.117 446.358 463.117C446.943 463.117 447.511 463.184 448.056 463.308C446.742 462.48 445.187 462 443.519 462C438.814 462 435 465.806 435 470.5C435 475.194 438.814 479 443.519 479C445.814 479 447.895 478.093 449.427 476.62C448.492 477.032 447.454 477.263 446.358 477.263C442.288 477.263 438.987 474.096 438.987 470.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M452.402 469.6L452.37 467.146L450.535 468.719L448.304 468.056L449.112 470.337L447.765 472.381L450.1 472.218L451.499 474.144L452.133 471.763L454.345 470.909L452.402 469.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.73aa26c04d74519a51642c23d8390d81.svg";
export { ForwardRef as ReactComponent };